import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Wallet01 = function Wallet01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 8.5H2m0 4h3.5467c.5402 0 .8103 0 1.0714.0466.2318.0413.458.1097.6738.204.2431.1061.4679.2559.9173.5556l.5816.3876c.4494.2997.6742.4495.9173.5556a3 3 0 0 0 .6738.204c.2611.0466.5312.0466 1.0714.0466h1.0934c.5402 0 .8103 0 1.0714-.0466a3 3 0 0 0 .6738-.204c.2431-.1061.4679-.2559.9173-.5556l.5816-.3876c.4494-.2997.6742-.4495.9173-.5556a3 3 0 0 1 .6738-.204c.2611-.0466.5312-.0466 1.0714-.0466H22M2 7.2v9.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 20 4.08 20 5.2 20h13.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.4802 22 17.9201 22 16.8V7.2c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C20.4802 4 19.9201 4 18.8 4H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 5.5198 2 6.08 2 7.2"
    })
  }));
};
export default Wallet01;